import React, { useEffect, useState } from "react";
import { Button, Modal, Alert, Row, Col, Table } from "react-bootstrap";
import ApiManager from "../utils/ApiManager"; // Adjust the path as per your directory structure
import "./Modal.css";
import { v4 as uuidv4 } from "uuid";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import RowCountLabel from "./RowCountLabel";
import CheckBoxComponent from "./CheckBoxComponent";
import DataManager from "../utils/DataManager";
import ProductLink from "./ProductLink";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import FiberNewIcon from "@mui/icons-material/FiberNew";

const ModalMovementOutgoings = ({
  movements,
  onCheckedChange,
  showModal,
  setShowModal,
  onSaveModal,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState("");
  const [pickingList, setPickingList] = useState([]);

  useEffect(() => {
    if (onCheckedChange) {
      onCheckedChange(pickingList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickingList]);

  const distributeQuantities = (tmpPickingList) => {
    const productQuantities = {};
    tmpPickingList.forEach((row) => {
      row.pickingList?.forEach((pickingListItem) => {
        if (!productQuantities[row.productId]) {
          productQuantities[row.productId] = {
            required: row.qty,
            totalQty: 0,
          };
        }
        productQuantities[row.productId].totalQty += row.qty;
      });
    });

    tmpPickingList.forEach((row) => {
      row.pickingList.forEach((pickingListItem) => {
        if (productQuantities[pickingListItem.productId].required > 0) {
          const availableQty = Math.min(
            pickingListItem.qty,
            productQuantities[pickingListItem.productId].required
          );
          pickingListItem.selectedQty = availableQty; // Assegna la massima quantità possibile fino alla quantità richiesta
          productQuantities[pickingListItem.productId].required -= availableQty;
        } else {
          pickingListItem.selectedQty = 0;
        }
      });
    });

    return tmpPickingList;
  };

  useEffect(() => {
    if (showModal) {
      setValidationError("");
      setError(null);
      ApiManager.Top.cellProducts(
        {
          pickingList: movements
            ?.filter((row) => row.selected)
            .map((row) => ({
              productId: row.productId,
              qty: row.qty,
            })),
        },
        (data) => {
          //   let tmpPickingList = movements
          //     ?.filter((row) => row.selected)
          //     .map((row) => ({
          //       ...row,
          //       pickingList: data?.filter(
          //         (item) => item.productId === row.productId && item.id !== row.id
          //       ),
          //     }));

          let tmpPickingList = [];
          movements
            ?.filter((row) => row.selected)
            .forEach((row) => {
              let newRow = { ...row };
              newRow.pickingList = data?.filter(
                (item) => item.productId === row.productId && item.id !== row.id
              );

              tmpPickingList.push(newRow);
            });

          tmpPickingList = distributeQuantities(tmpPickingList);

          setPickingList(tmpPickingList);
        },
        (error) => {
          setError(error);
        },
        () => {}
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  const closeModal = () => {
    setShowModal(false);
  };

  const validateFields = () => {
    // Implement your validation logic here if needed
    return "";
  };

  // Handler for picking list quantity change
  const handlePickingListQtyChange = (index, pickingListIndex, event) => {
    const newData = [...pickingList];
    let selectedQty = parseInt(event.target.value);
    newData[index].pickingList[pickingListIndex].selectedQty = selectedQty;
    setPickingList(newData);
  };

  // Handler for checkbox change
  const handleCheckboxChange = (rowId) => {
    const updatedRows = pickingList.map((row) =>
      row.id === rowId ? { ...row, selected: !row.selected } : row
    );
    setPickingList(updatedRows);
  };

  const saveModal = () => {
    const error = validateFields();
    if (error) {
      setValidationError(error);
      return;
    }
    const newGuid = uuidv4();

    const outgoings = pickingList?.filter((movement) => movement.selected);
    // ?.map((movement) => ({
    //   ...movement,
    //   qty: movement.selectedQty,
    // }));

    ApiManager.Top.stockOutgoings(
      newGuid,
      outgoings,
      (data) => {
        onSaveModal(data);
        setShowModal(false);
      },
      (error) => {
        console.error("Error during API call:", error);
        setValidationError("Errore durante il salvataggio. Riprova.");
      },
      () => {}
    );
  };

  return (
    <Modal
      className="incomingModals"
      show={showModal}
      onHide={closeModal}
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <strong className="header-text">Scarico</strong>
      </Modal.Header>
      <Modal.Body>
        {validationError && <Alert variant="danger">{validationError}</Alert>}
        <Row className="mb-3">
          <Col>
            <RowCountLabel
              count={pickingList?.length}
              label="Articoli da caricare"
            />
            <Table striped>
              <thead>
                <tr>
                  <th style={{ width: "64px" }}></th>
                  <th>Documento</th>
                  <th>Articolo</th>
                  <th>Cliente</th>
                  <th className="text-end" style={{ width: "100px" }}>
                    Anno
                  </th>
                  <th className="text-end" style={{ width: "170px" }}>
                    Qta
                  </th>
                  <th>Ubicazione</th>
                </tr>
              </thead>
              <tbody>
                {pickingList
                  // ?.filter((row) => row.selected)
                  ?.map((row, rowIndex) => (
                    <React.Fragment key={`row-${row.id}`}>
                      <tr
                        style={{ verticalAlign: "middle", fontWeight: "bold" }}
                      >
                        <td className="text-center">
                          <CheckBoxComponent
                            id={`qty-${row.id}`}
                            checked={row.selected}
                            onChange={() => handleCheckboxChange(row.id)}
                          />
                        </td>
                        <td>
                          <ul className="list-unstyled">
                            <li>
                              {row.docTypeDescr}&nbsp;
                              {row.docNumb}
                              {row.docSeries?.trim() ? "/" + row.docSeries : ""}
                              &nbsp;
                              {DataManager.Date.format(
                                row.docDate,
                                "dd/MM/yyyy"
                              )}
                              {/* <span className="half-parent-text">&nbsp;{row.id}</span> */}
                            </li>
                            <li>
                              <span className="half-parent-text">
                                {row.transpReasonDescr}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td>
                          <ProductLink {...row} showProductLink={false} />
                        </td>
                        <td>
                          <ul className="list-unstyled">
                            <li>{row.customerDescr}</li>
                            <li>
                              <span className="half-parent-text">
                                {row.customerId}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td className="text-end"></td>
                        <td className="text-end">
                          {row.pickingList &&
                            (row.pickingList?.reduce(
                              (sum, mov) => sum + mov.selectedQty,
                              0
                            ) === row.qty ? (
                              <CheckCircleIcon className="me-3 text-success" />
                            ) : (
                              <WarningIcon className="me-3 text-danger" />
                            ))}
                          {row.noStock && <FiberNewIcon className="me-3" />}
                          {DataManager.Decimal.format(row.qty, 0)}
                          {row.origQty &&
                            row.origQty !== row.qty &&
                            " / " + DataManager.Decimal.format(row.origQty, 0)}
                        </td>
                        <td></td>
                      </tr>
                      {row.pickingList?.length > 0 &&
                        row.pickingList.map(
                          (pickingListItem, pickingListIndex) => (
                            <tr
                              key={`rowPl-${row.id}-${pickingListIndex}`}
                              style={{
                                fontStyle: "italic",
                                opacity: 0.8,
                                verticalAlign: "middle",
                              }}
                            >
                              <td colSpan={2}></td>
                              <td>
                                <ul className="list-unstyled">
                                  <li>{pickingListItem.customerDescr}</li>
                                  <li>
                                    <span className="half-parent-text">
                                      {pickingListItem.customerId}
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td>
                                <ul className="list-unstyled">
                                  <li>{pickingListItem.supplierDescr}</li>
                                  <li>
                                    <span className="half-parent-text">
                                      {pickingListItem.supplierId}
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td className="text-end">
                                {pickingListItem.productYear}
                              </td>
                              <td>
                                <div className="d-flex justify-content-between align-items-center">
                                  <select
                                    id={`qty-${row.id}-${pickingListItem.id}`}
                                    value={pickingListItem.selectedQty || 0}
                                    onChange={(event) =>
                                      handlePickingListQtyChange(
                                        rowIndex,
                                        pickingListIndex,
                                        event
                                      )
                                    }
                                    className="form-select text-end"
                                    style={{ width: "100px" }}
                                  >
                                    {Array.from(
                                      { length: row.qty + 1 },
                                      (_, i) => row.qty - i
                                    ).map((qty) => (
                                      <option key={qty} value={qty}>
                                        {qty}
                                      </option>
                                    ))}
                                  </select>
                                  &nbsp; / &nbsp;
                                  <span>
                                    {DataManager.Decimal.format(
                                      pickingListItem.qty,
                                      0
                                    )}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div>
                                    <ul className="list-unstyled">
                                      <li>
                                        {pickingListItem.warehouseAreaDescr}-
                                        {pickingListItem.rack}-
                                        {pickingListItem.col}-
                                        {pickingListItem.shelf}
                                      </li>
                                      <li>
                                        {pickingListItem.lastMovData && (
                                          <span className="half-parent-text">
                                            {`Ult. mov. ${pickingListItem.lastMovData}`}
                                          </span>
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                    </React.Fragment>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          title="Salva"
          variant="success"
          onClick={saveModal}
          disabled={pickingList?.some(
            (row) =>
              row.selected &&
              row.pickingList?.reduce(
                (sum, mov) => sum + mov.selectedQty,
                0
              ) !== row.qty
          )}
        >
          <SaveAltIcon />
        </Button>
        {/* <Button variant="secondary" onClick={closeModal}>
          Chiudi
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalMovementOutgoings;
